import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
const MAX_VISIBLE = 6;
const fullName = (c) => `${c.firstName} ${c.lastName}`.trim() || c.email;
export const MentionPicker = ({ query, collaborators, excludedUserIds = [], anchor, onPick, onClose, }) => {
    const containerRef = useRef(null);
    const matches = useMemo(() => {
        const q = query.trim().toLowerCase();
        const excluded = new Set(excludedUserIds);
        return collaborators
            .filter(c => !excluded.has(c.userId))
            .filter(c => {
            if (!q)
                return true;
            const hay = `${c.firstName} ${c.lastName} ${c.email}`.toLowerCase();
            return hay.includes(q);
        })
            .slice(0, MAX_VISIBLE);
    }, [query, collaborators, excludedUserIds]);
    useEffect(() => {
        const handleClickOutside = (e) => {
            var _a;
            if (!((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)))
                onClose();
        };
        const handleKey = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKey);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKey);
        };
    }, [onClose]);
    if (matches.length === 0)
        return null;
    return createPortal(_jsx("div", { ref: containerRef, className: "fixed py-1 rounded shadow-lg min-w-[220px] max-h-[280px] overflow-y-auto", style: {
            left: anchor.x,
            top: anchor.y,
            backgroundColor: 'var(--charcoal)',
            border: '1px solid var(--pewter)',
            zIndex: 9999,
        }, children: matches.map(c => (_jsxs("button", { onClick: () => onPick(c), onMouseDown: (e) => e.preventDefault(), className: "w-full flex items-center gap-2 px-3 py-2 text-xs text-left hover:bg-white/10 transition-colors", style: { color: 'var(--sand)' }, children: [_jsx("span", { className: "flex-1 truncate", children: fullName(c) }), _jsx("span", { className: "text-[10px] truncate", style: { color: 'var(--dew)', maxWidth: 120 }, children: c.email })] }, c.userId))) }), document.body);
};
